<script lang="ts">
	import { user_settings } from 'src/stores/account/user';
	import { format } from 'svelte-i18n';

	import { handlePushPermissions } from './user_permissions_helper';

	import NotificationToggler from './NotificationToggler.svelte';
</script>

<NotificationToggler
	enabled={$user_settings.push_notifications_permissions}
	description={$format('user_push_notification_enable')}
	request={handlePushPermissions}
/>
